<template>
  <v-snackbar v-model="snackbarLocal" right top :color="color">
    {{ message }}

    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="snackbarLocal = false">
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: "valert",
  props: ["message", "snackbar", "color"],
  data() {
    return {
      snackbarLocal: false,
    };
  },
  watch: {
    snackbar(val) {
      this.snackbarLocal = val;
    },
    snackbarLocal(val) {
      val || this.closeSnackBar();
    },
  },
  methods: {
    closeSnackBar() {
      this.snackbarLocal = false;
    },
  },
};
</script>
